import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import Table from "../../../core/common/dataTable/index";
import useApi from "../../../core/customhook/useApi";
import { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PredefinedDateRanges from "../../../core/common/datePicker";
import moment from "moment";
import { Moment } from "moment";
import dayjs from "dayjs";

const MyattendanceRegularization = () => {
  const [regu, setRegu] = useState([]);
  const [modalData, setModalData] = useState<any>([]);
  const [callAgain, setCallAgain] = useState(0);
  const [reguStatus, setReguStatus] = useState("")
  const [selectedDateRange, setSelectedDateRange] = useState<{
    from: string;
    to: string;
  }>({
    from: moment().startOf('month').format("YYYY-MM-DD"),
    to: moment().endOf('month').format("YYYY-MM-DD"),
  });

  const handleStatusChange = (e: any) => {
    setReguStatus(e.target.value);
  };

  const {
    data: attendancereguData,
    loading: attendancereguLoading,
    error: attendancereguErrro,
  } = useApi("/api/get-regularization-details", {
    method: "POST",
    payload: {
      status: reguStatus,
      from: selectedDateRange.from,
      to: selectedDateRange.to,
    },
    autoCall: true,
    dependencies: [callAgain, reguStatus, selectedDateRange],
  });
  useEffect(() => {
    if (attendancereguData?.success) {
      setRegu(attendancereguData?.data);
    }
  }, [attendancereguData]);

  const columns = [
    {
      title: "Date",
      dataIndex: "attendance_regn_date",
      render: (text: string) => dayjs(text).format("D MMMM YYYY"), // e.g. 10 October 2025
      sorter: (a: any, b: any) =>
        dayjs(a.attendance_regn_date).unix() - dayjs(b.attendance_regn_date).unix(),
    }
    ,

    {
      title: "In Time",
      dataIndex: "self_regn_in_time",
      sorter: (a: any, b: any) =>
        new Date(a.self_regn_in_time).getTime() -
        new Date(b.self_regn_in_time).getTime(),
    },
    {
      title: "Out Time ",
      dataIndex: "self_regn_out_time",
      sorter: (a: any, b: any) =>
        new Date(a.self_regn_out_time).getTime() -
        new Date(b.self_regn_out_time).getTime(),
    },
    {
      title: "Hours",
      dataIndex: "self_regn_hours",
      sorter: (a: any, b: any) => a.self_regn_hours - b.self_regn_hours,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      sorter: (a: any, b: any) => a.reason.localeCompare(b.reason),
    },
    {
      title: "Status",
      dataIndex: "regularisation_status",
      render: (text: string) => (
        <span
          className={`badge ${text.toLowerCase().includes("approved") ? "bg-success" : text.toLowerCase().includes("pending") ? "bg-warning" : "bg-danger"
            }`}
        >
          {text}
        </span>
      ),
      sorter: (a: any, b: any) =>
        a.regularisation_status.localeCompare(b.regularisation_status),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <>
          <Link
            to="#"
            className="text-success me-2"
            title="View"
            data-bs-toggle="modal"
            data-bs-target="#apply-modal"
            onClick={() => setModalData(record)}
          >
            <i className="ti ti-eye" />
          </Link>
          <Link
            to="#"
            className="text-danger"
            style={{
              cursor:
                record?.regularisation_status === "PENDING"
                  ? "pointer"
                  : "not-allowed",
            }}
            title="Delete"
            onClick={() => {
              if (record?.regularisation_status === "PENDING")
                deleteRequest(record?.regularization_id);
            }}
          >
            <i className="ti ti-trash" />
          </Link>
        </>
      ),
    },
  ];

  const {
    data: attendancereguDatadelete,
    loading: attendanceregudeleteLoading,
    error: attendanceregudeleteError,
    callApi: deleteRecord,
  } = useApi("", {
    method: "DELETE",
    autoCall: false,
  });

  const deleteRequest = async (id: any) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "Once deleted, you won't be able to recover this regularization!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      });
      if (result.isConfirmed) {
        const response = await deleteRecord(
          undefined,
          "/api/delete-regularization-details/" + id
        );
        if (response.success) {
          Swal.fire(
            "Deleted!",
            "Your regularization has been deleted.",
            "success"
          );
          setCallAgain(callAgain + 1);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

const formatDateTime = (date: any, time = "") => {
  if (!date) return "N/A";
  if (!time) {
    return dayjs(date).format("DD MMMM YYYY");
  }
  const dateTime = `${date} ${time}`;
  return dayjs(dateTime).format("DD MMMM YYYY, hh:mm A");
};

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Attendance Regularization</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Attendance</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Attendance Regularization List
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          <div className="card">

            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                {/* Application Status Filters */}
                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusAll"
                    name="applicationStatus"
                    value=""
                    checked={reguStatus === ""}
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="statusAll">
                    All
                  </label>
                </div>

                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusPending"
                    name="applicationStatus"
                    value="PENDING"
                    checked={reguStatus === "PENDING"}
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="statusPending">
                    Pending
                  </label>
                </div>

                <div className="form-check me-3">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusApproved"
                    name="applicationStatus"
                    value="APPROVED"
                    checked={reguStatus === "APPROVED"}
                    onChange={handleStatusChange}
                  />
                  <label className="form-check-label" htmlFor="statusApproved">
                    Approved
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="radio"
                    id="statusRejected"
                    name="applicationStatus"
                    value="REJECTED"
                    onChange={handleStatusChange}
                    checked={reguStatus === "REJECTED"}
                  />
                  <label className="form-check-label" htmlFor="statusRejected">
                    Rejected
                  </label>
                </div>
              </div>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="me-3">
                  <div className="input-icon-end position-relative">
                    <PredefinedDateRanges
                      onChange={(start: Moment, end: Moment) => {
                        setSelectedDateRange({
                          from: start.format("YYYY-MM-DD"),
                          to: end.format("YYYY-MM-DD"),
                        });
                      }}
                    />
                    <span className="input-icon-addon">
                      <i className="ti ti-chevron-down" />
                    </span>
                  </div>
                </div>


              </div>

            </div>

            <div className="card-body p-0">
              <Table dataSource={regu} columns={columns} Selection={false} limit={31} showSearchInput={true} />
            </div>
          </div>
        </div>
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>

      <div
        id="apply-modal"
        className="modal fade"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="apply-modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="apply-modalLabel">
                Regularization Details
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <strong>Attendance Date:</strong>
                  <p className="text-muted">{formatDateTime(modalData?.attendance_regn_date)}</p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Shift Time:</strong>
                  <p className="text-muted">
                    {modalData?.shift_start_time} - {modalData?.shift_end_time}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Self In Time:</strong>
                  <p className="text-muted">
                    {formatDateTime(modalData?.self_regn_in_date, modalData?.self_regn_in_time)}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Self Out Time:</strong>
                  <p className="text-muted">
                    {formatDateTime(modalData?.self_regn_out_date, modalData?.self_regn_out_time)}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Total Self Hours:</strong>
                  <p className="text-muted">
                    {modalData?.self_regn_hours || "N/A"}
                  </p>
                </div>

                {(modalData?.manager_regn_in_date ||
                  modalData?.manager_regn_in_time ||
                  modalData?.manager_regn_out_date ||
                  modalData?.manager_regn_out_time ||
                  modalData?.manager_regn_hours) && (
                    <>
                      <div className="col-md-12">
                        <h6 className="mt-2 mb-3 text-secondary">
                          Manager Attendance Details
                        </h6>
                      </div>

                      <div className="col-md-6 mb-3">
                        <strong>Manager In Time:</strong>
                        <p className="text-muted">
                          {formatDateTime(modalData?.manager_regn_in_date, modalData?.manager_regn_in_time)}
                        </p>
                      </div>

                      <div className="col-md-6 mb-3">
                        <strong>Manager Out Time:</strong>
                        <p className="text-muted">
                          {formatDateTime(modalData?.manager_regn_out_date, modalData?.manager_regn_out_time)}
                        </p>
                      </div>

                      <div className="col-md-6 mb-3">
                        <strong>Total Manager Hours:</strong>
                        <p className="text-muted">
                          {modalData?.manager_regn_hours || "N/A"}
                        </p>
                      </div>
                    </>
                  )}

                <div className="col-md-6 mb-3">
                  <strong>Status:</strong>
                  <p>
                    <span
                      className={`badge ${modalData?.regularisation_status === "APPROVED"
                        ? "bg-success"
                        : modalData?.regularisation_status === "REJECTED"
                          ? "bg-danger"
                          : "bg-danger"
                        }`}
                    >
                      {modalData?.regularisation_status || "PENDING"}
                    </span>
                  </p>
                </div>

                <div className="col-md-12 mb-3">
                  <strong>Reason:</strong>
                  <p className="text-muted">{modalData?.reason || "N/A"}</p>
                </div>

                {modalData?.manager_reason && (
                  <div className="col-md-12 mb-3">
                    <strong>Manager Reason:</strong>
                    <p className="text-muted">{modalData?.manager_reason}</p>
                  </div>
                )}

                <div className="col-md-6 mb-3">
                  <strong>Approved By:</strong>
                  <p className="text-muted">
                    {modalData?.approved_by || "N/A"}
                  </p>
                </div>

                <div className="col-md-6 mb-3">
                  <strong>Rejected By:</strong>
                  <p className="text-muted">
                    {modalData?.rejected_by || "N/A"}
                  </p>
                </div>

                <div className="col-md-12 mb-3">
                  <strong>Created On:</strong>
                 <p className="text-muted">{formatDateTime(modalData?.created_on)}</p>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyattendanceRegularization;
